import { Children, cloneElement } from "react";

export default function renderChildren(children, props) {
	if (!children) {
		return null;
	}

	// If children is a string, return it directly
	if (typeof children === "string") {
		return children;
	}

	// If children is a single React element, clone it with the provided props
	if (Children.count(children) === 1) {
		return cloneElement(children, props);
	}

	// If children is an array or a React fragment, clone each child with the provided props
	if (Children.count(children) > 0) {
		return Children.map(children, (child) => {
			return cloneElement(child, props);
		});
	}

	// If children is a function, call it with the provided props
	if (typeof children === "function") {
		return children(props);
	}

	return null;
}
